const SUBMENU_TYPES = {
  CONTACT: 'contact',
  NOTE: 'note',
  MEETING: 'meeting',
};

export { SUBMENU_TYPES };
